import React, { createContext, useContext, useEffect, useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from './AuthContext';

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);
export const validTheme = value => ['light', 'dark', 'system'].includes(value);
const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
const write = (key, value) => { try { localStorage.setItem(key, value); } catch { /* Device storage can be unavailable. */ } };

export function ThemeProvider({ children }) {
  const { usuario, perfil } = useAuth();
  const [preference, setPreference] = useState(() => validTheme(read('pruvenx:theme')) ? read('pruvenx:theme') : 'system');
  const [systemDark, setSystemDark] = useState(() => window.matchMedia?.('(prefers-color-scheme: dark)').matches || false);
  const [error, setError] = useState('');
  useEffect(() => {
    const media = window.matchMedia?.('(prefers-color-scheme: dark)');
    const changed = event => setSystemDark(event.matches);
    media?.addEventListener?.('change', changed);
    return () => media?.removeEventListener?.('change', changed);
  }, []);
  useEffect(() => {
    const pending=usuario?.uid&&read(`pruvenx:themePending:${usuario.uid}`);
    const saved = (validTheme(pending)&&pending) || perfil?.themePreference || read(`pruvenx:theme:${usuario?.uid}`) || read('pruvenx:theme');
    if (validTheme(saved)) setPreference(saved);
  }, [usuario?.uid, perfil?.themePreference]);
  const resolved = preference === 'system' ? (systemDark ? 'dark' : 'light') : preference;
  useEffect(() => {
    document.documentElement.dataset.theme = resolved;
    document.documentElement.style.colorScheme = resolved;
    write('pruvenx:theme', preference);
  }, [resolved, preference]);
  const setTheme = async value => {
    if (!validTheme(value)) return;
    setPreference(value); setError('');
    write('pruvenx:theme', value);
    if (usuario?.uid) {
      write(`pruvenx:theme:${usuario.uid}`, value);
      write(`pruvenx:themePending:${usuario.uid}`,value);
      try { await updateDoc(doc(db, 'usuarios', usuario.uid), { themePreference: value });try{localStorage.removeItem(`pruvenx:themePending:${usuario.uid}`);}catch{} }
      catch { setError('A aparência foi salva neste navegador. Não foi possível sincronizar com sua conta.'); }
    }
  };
  return <ThemeContext.Provider value={{ preference, resolved, setTheme, error }}>{children}</ThemeContext.Provider>;
}
